import { Filter } from '../utils/expFilter';

export const Camera = class {
    room;
    ortoCam;
    constructor(camera, v3dtools, room, app) {
        this.room = room;
        this.v3dtools = v3dtools;
        this.camera = camera;
        this.app = app;
        // this.camera.position.set(1, 1, 5);
        this.isZoming = false;
        this.firstUpdate = true;
        this.width = 1.5;
        this.height = 1.5;
        this.filter = new Filter(0.05);
        this.orthoCam = new v3d.OrthographicCamera(10  / - 2, 10 / 2, 10 / 2, 10 / - 2, 0.01, 1000);
        this.app.scene.add(this.orthoCam);
    }

    continuousZoom() {
        requestAnimationFrame(() => {
            const maxSize = Math.max(this.width, this.height * 1.1);
            const zoom = 2 / Math.pow(maxSize, 0.8) - 0.03;

            if (this.firstUpdate) {
                this.camera.zoom = zoom;
                this.isZoming = false;
                setTimeout(() => {
                    this.firstUpdate = false;
                }, 1000);
            } else {
                this.camera.zoom = this.filter.newValue(zoom);
            }
            this.continuousZoom();
        });
    }

    updateCamZoom(width, height) {
        this.width = width;
        this.height = height;

        // if (this.isZoming) {
        //     return
        // }
        // this.isZoming = true;
        // const duration = 0.5;
        // const maxSize = Math.max(this.width, this.height*1.1);
        // const zoom =  0.8/Math.pow(maxSize, 0.8) - 0.03;
        // let minZoom;
        // let maxZoom;
        // if (zoom > this.camera.zoom) {
        //     maxZoom = zoom;
        //     minZoom = this.camera.zoom;
        // } else {
        //     minZoom = zoom;
        //     maxZoom = this.camera.zoom;
        // }
        //
        // if (this.firstUpdate) {
        //     this.camera.zoom = zoom;
        //     this.isZoming = false;
        //     setTimeout(()=>{
        //         this.firstUpdate = false;
        //     }, 1000)
        //     return;
        // }
        //
        // tweenVal(
        //     this.camera.zoom,
        //     zoom,
        //     duration,
        //     (tweenZoom)=>{
        //         let smoothstep = v3d.MathUtils.smootherstep(tweenZoom,minZoom,maxZoom)
        //         this.camera.zoom = (1 - smoothstep) * minZoom  + smoothstep * maxZoom;
        //     },
        //     ()=>{
        //         this.isZoming = false;
        //     })
    }

    updateCam(viewCenter, position, customdDuration) {
        let duration = customdDuration ?? 0.01;
        // if (this.firstUpdate) {
        //     duration = 0.01;
        //     setTimeout(() => {
        //         this.firstUpdate = false;
        //     }, 1000);
        //     // return;
        // }

        this.v3dtools.tweenCamera(
            [ position.x, -position.z, position.y ], //x, -z, y
            new v3d.Vector3(viewCenter.x, viewCenter.z, viewCenter.y).toArray(),
            duration,
            () => {
                // this.updateCamZoom(width, height);
            },
            0,
        );
    }

    topCamMode(force)  {
        this.app.setCamera(this.camera);
        this.updateCam({
                x: this.room.width/2,
                y: 0,
                z: -this.room.depth/2,
            },
            {
                x: this.room.width/2,
                y: 20,
                z: this.room.depth/2,
            }, force? 0.01 : 1);
    }

    standardCamMode(force)  {
        this.app.setCamera(this.camera);
        this.updateCam({
                x: this.room.width/3,
                y: this.room.height/2,
                z: 0,
            },
            {
                x: this.room.width/3,
                y: 4,
                z: 6,
            }, force? 0.01 : 1);
    }

    wallDistance = 6;
    setOrthoCam(width, height, x,y,z, lx,ly,lz) {
        const shift = 0.5;
        const halfWidth = (width + shift)/2;
        const halfHeight = (height + shift)/2;
        this.orthoCam.left = -halfWidth;
        this.orthoCam.right = halfWidth;
        this.orthoCam.bottom = -halfHeight;
        this.orthoCam.top = halfHeight;
        this.orthoCam.position.set(x,y,z);
        this.orthoCam.lookAt(lx,ly,lz);
        this.orthoCam.updateProjectionMatrix();
        // console.log(this.orthoCam);
        this.app.setCamera(this.orthoCam);
    }
    wallFront(force)  {
        // Рассчитываем расстояние от камеры до границ объекта с учетом поля зрения
        // const fov = this.camera.fov * (Math.PI / 180);
        // const distance = 0.5 * this.room.width / Math.sin(fov / 2);


        // this.updateCam({
        //         x: this.room.width/2,
        //         y: this.room.height/2,
        //         z: 0,
        //     },
        //     {
        //         x: this.room.width/2,
        //         y: this.room.height/2,
        //         z: distance,
        //     }, force? 0.01 : 1);

        // this.orthoCam.position.copy(this.camera.position);
        // this.orthoCam.rotation.copy(this.camera.rotation);
        this.setOrthoCam(
            this.room.width, this.room.height,
            this.room.width/2, this.room.height/2,5,
            this.room.width/2, this.room.height/2,0,
        );
    }

    wallLeft(force)  {
        // Рассчитываем расстояние от камеры до границ объекта с учетом поля зрения
        // const fov = this.camera.fov * (Math.PI / 180);
        // const distance = 0.5 * this.room.depth / Math.sin(fov / 2);

        // this.updateCam({
        //         x: 0,
        //         y: this.room.height/2,
        //         z: -this.room.depth/2,
        //     },
        //     {
        //         x: distance,
        //         y: this.room.height/2,
        //         z: this.room.depth/2,
        //     }, force? 0.01 : 1);

        this.setOrthoCam(
            this.room.depth, this.room.height,
            5, this.room.height/2,this.room.depth/2,
            0, this.room.height/2,this.room.depth/2,
        );
    }

    wallRight(force)  {
        // Рассчитываем расстояние от камеры до границ объекта с учетом поля зрения
        // const fov = this.camera.fov * (Math.PI / 180);
        // const distance = 0.5 * this.room.depth / Math.sin(fov / 2);
        //
        // this.updateCam({
        //         x: this.room.width,
        //         y: this.room.height/2,
        //         z: -this.room.depth/2,
        //     },
        //     {
        //         x: this.room.width - distance,
        //         y: this.room.height/2,
        //         z: this.room.depth/2,
        //     }, force? 0.01 : 1);

        this.setOrthoCam(
            this.room.depth, this.room.height,
            0, this.room.height/2,this.room.depth/2,
            5, this.room.height/2,this.room.depth/2,
        );
    }

    wallBack(force)  {
        // Рассчитываем расстояние от камеры до границ объекта с учетом поля зрения
        // const fov = this.camera.fov * (Math.PI / 180);
        // const distance = 0.5 * this.room.width / Math.sin(fov / 2);
        //
        // this.updateCam({
        //         x: this.room.width/2,
        //         y: this.room.height/2,
        //         z: -this.room.depth,
        //     },
        //     {
        //         x: this.room.width/2,
        //         y: this.room.height/2,
        //         z: this.room.depth - distance,
        //     }, force? 0.01 : 1);

        this.setOrthoCam(
            this.room.width, this.room.height,
            this.room.width/2, this.room.height/2,0,
            this.room.width/2, this.room.height/2,5,
        );
    }
};
